var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 13,
    fill: "#F2F2F2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_98_2878)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.3333,
    height: 17.3333,
    transform: "translate(4.33203 4.33301)",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0545 8.96267L17.0361 7.94434L12.9989 11.9816L8.96169 7.94434L7.94336 8.96267L11.9806 12.9999L7.94336 17.0371L8.96169 18.0554L12.9989 14.0182L17.0361 18.0554L18.0545 17.0371L14.0172 12.9999L18.0545 8.96267Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_98_2878"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.3333,
    height: 17.3333,
    fill: "white",
    transform: "translate(4.33203 4.33301)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteClose);
export default __webpack_public_path__ + "static/media/white_close.a0315867758dd0a916171973913b4332.svg";
export { ForwardRef as ReactComponent };